// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/feedback/v1/types.proto (package creativefabrica.feedback.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/feedback/v1/types.proto.
 */
export const file_creativefabrica_feedback_v1_types: GenFile = /*@__PURE__*/
  fileDesc("CidjcmVhdGl2ZWZhYnJpY2EvZmVlZGJhY2svdjEvdHlwZXMucHJvdG8SG2NyZWF0aXZlZmFicmljYS5mZWVkYmFjay52MSKRAgoIRmVlZGJhY2sSRAoLdGFyZ2V0X3R5cGUYASABKA4yLy5jcmVhdGl2ZWZhYnJpY2EuZmVlZGJhY2sudjEuRmVlZGJhY2tUYXJnZXRUeXBlEhEKCXRhcmdldF9pZBgCIAEoCRI7CgZyYXRpbmcYAyABKA4yKy5jcmVhdGl2ZWZhYnJpY2EuZmVlZGJhY2sudjEuRmVlZGJhY2tSYXRpbmcSDwoHY29tbWVudBgEIAEoCRIuCgpjcmVhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCpoCg5GZWVkYmFja1JhdGluZxIfChtGRUVEQkFDS19SQVRJTkdfVU5TUEVDSUZJRUQQABIYChRGRUVEQkFDS19SQVRJTkdfTElLRRABEhsKF0ZFRURCQUNLX1JBVElOR19ESVNMSUtFEAIqXwoSRmVlZGJhY2tUYXJnZXRUeXBlEiQKIEZFRURCQUNLX1RBUkdFVF9UWVBFX1VOU1BFQ0lGSUVEEAASIwofRkVFREJBQ0tfVEFSR0VUX1RZUEVfR0VORVJBVElPThABQlNaUWdpdGh1Yi5jb20vY3JlYXRpdmVmYWJyaWNhL3NjaGVtYXMvcGtnL2dlbi9jcmVhdGl2ZWZhYnJpY2EvZmVlZGJhY2svdjE7ZmVlZGJhY2t2MWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * Feedback is one user's feedback on one target: an optional like / dislike
 * and an optional free-text comment. A user holds at most one Feedback per
 * target; giving feedback again updates it.
 *
 * @generated from message creativefabrica.feedback.v1.Feedback
 */
export type Feedback = Message<"creativefabrica.feedback.v1.Feedback"> & {
  /**
   * @generated from field: creativefabrica.feedback.v1.FeedbackTargetType target_type = 1;
   */
  targetType: FeedbackTargetType;

  /**
   * target_id identifies the target within target_type.
   *
   * @generated from field: string target_id = 2;
   */
  targetId: string;

  /**
   * rating is FEEDBACK_RATING_UNSPECIFIED when the user gave no rating.
   *
   * @generated from field: creativefabrica.feedback.v1.FeedbackRating rating = 3;
   */
  rating: FeedbackRating;

  /**
   * comment is the user's free-text comment; empty when none was given.
   *
   * @generated from field: string comment = 4;
   */
  comment: string;

  /**
   * created_at is when the user first gave feedback on the target.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * updated_at is when the feedback last changed.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Feedback is one user's feedback on one target: an optional like / dislike
 * and an optional free-text comment. A user holds at most one Feedback per
 * target; giving feedback again updates it.
 *
 * @generated from message creativefabrica.feedback.v1.Feedback
 */
export type FeedbackJson = {
  /**
   * @generated from field: creativefabrica.feedback.v1.FeedbackTargetType target_type = 1;
   */
  targetType?: FeedbackTargetTypeJson;

  /**
   * target_id identifies the target within target_type.
   *
   * @generated from field: string target_id = 2;
   */
  targetId?: string;

  /**
   * rating is FEEDBACK_RATING_UNSPECIFIED when the user gave no rating.
   *
   * @generated from field: creativefabrica.feedback.v1.FeedbackRating rating = 3;
   */
  rating?: FeedbackRatingJson;

  /**
   * comment is the user's free-text comment; empty when none was given.
   *
   * @generated from field: string comment = 4;
   */
  comment?: string;

  /**
   * created_at is when the user first gave feedback on the target.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: TimestampJson;

  /**
   * updated_at is when the feedback last changed.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.feedback.v1.Feedback.
 * Use `create(FeedbackSchema)` to create a new message.
 */
export const FeedbackSchema: GenMessage<Feedback, {jsonType: FeedbackJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_feedback_v1_types, 0);

/**
 * FeedbackRating is a user's verdict on a feedback target.
 *
 * @generated from enum creativefabrica.feedback.v1.FeedbackRating
 */
export enum FeedbackRating {
  /**
   * FEEDBACK_RATING_UNSPECIFIED means no rating: never given, or cleared.
   *
   * @generated from enum value: FEEDBACK_RATING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FEEDBACK_RATING_LIKE = 1;
   */
  LIKE = 1,

  /**
   * @generated from enum value: FEEDBACK_RATING_DISLIKE = 2;
   */
  DISLIKE = 2,
}

/**
 * FeedbackRating is a user's verdict on a feedback target.
 *
 * @generated from enum creativefabrica.feedback.v1.FeedbackRating
 */
export type FeedbackRatingJson = "FEEDBACK_RATING_UNSPECIFIED" | "FEEDBACK_RATING_LIKE" | "FEEDBACK_RATING_DISLIKE";

/**
 * Describes the enum creativefabrica.feedback.v1.FeedbackRating.
 */
export const FeedbackRatingSchema: GenEnum<FeedbackRating, FeedbackRatingJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_feedback_v1_types, 0);

/**
 * FeedbackTargetType is the kind of entity feedback is left on. It names what
 * Feedback.target_id identifies.
 *
 * @generated from enum creativefabrica.feedback.v1.FeedbackTargetType
 */
export enum FeedbackTargetType {
  /**
   * @generated from enum value: FEEDBACK_TARGET_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * FEEDBACK_TARGET_TYPE_GENERATION is a genai generation; target_id is its
   * creativefabrica.modality.v1.Generation.generation_id.
   *
   * @generated from enum value: FEEDBACK_TARGET_TYPE_GENERATION = 1;
   */
  GENERATION = 1,
}

/**
 * FeedbackTargetType is the kind of entity feedback is left on. It names what
 * Feedback.target_id identifies.
 *
 * @generated from enum creativefabrica.feedback.v1.FeedbackTargetType
 */
export type FeedbackTargetTypeJson = "FEEDBACK_TARGET_TYPE_UNSPECIFIED" | "FEEDBACK_TARGET_TYPE_GENERATION";

/**
 * Describes the enum creativefabrica.feedback.v1.FeedbackTargetType.
 */
export const FeedbackTargetTypeSchema: GenEnum<FeedbackTargetType, FeedbackTargetTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_feedback_v1_types, 1);

